import styled from "@emotion/styled";

export const StyledSearchBar = styled(
    "div",
    {
        shouldForwardProp(propName) {
            return !["fullWidth", "switchToVerticalOnMobile"].includes(propName);
        },
    }
)<{ fullWidth?: boolean; switchToVerticalOnMobile?: boolean }>(({ theme, fullWidth, switchToVerticalOnMobile }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: fullWidth ? "100%" : "auto",
    gap: theme.spacing(1),
    // if switchToVerticalOnMobile, on mobile, switch to vertical layout
    ...(switchToVerticalOnMobile ? { [theme.breakpoints.down("sm")]: { flexDirection: "column", width: "100%" } } : {}),
}));

export const StyledKeywordSearchWrapper = styled(
    "div",
    {
        shouldForwardProp(propName) {
            return propName !== "fullWidth";
        },
    }
)<{ fullWidth?: boolean }>(({ theme, fullWidth }) => ({
    width: fullWidth ? "100%" : "auto",
}));

export const StyledMenuWrapper = styled("div")<{ hasButtons: boolean }>(({ hasButtons, theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    flexGrow: 1,
    [theme.breakpoints.down("sm")]: {
        flexGrow: hasButtons ? 1 : 0,
    },
}));

export const StyledButtonsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));
